<template>
	<div>
		<ihead :checkindex="checkindex"></ihead>
		<div class="banner-box">
			<h1>{{title}}</h1>
		</div>
		<mu-container>
			<mu-breadcrumbs>
				<mu-breadcrumbs-item
					v-for="(item, index) in items"
					:key="index"
					:to="item.to"
					:disabled="item.disabled"
					>{{ item.text }}</mu-breadcrumbs-item>
			</mu-breadcrumbs>
		</mu-container>
    <div class="text-center warp">
      <vue2-org-tree name="test" :data="data" :label-class-name="labelClassName"/>
    </div> 
		<ifoot></ifoot>
		<returntop class="return-top"></returntop>
	</div>
</template>

<script>
import ihead from "@/components/ihead.vue"
import ifoot from '@/components/ifoot.vue'
import crumbs from "@/components/crumbs.vue"
import returntop from '@/components/returntop'
export default {
components: {
		ihead,ifoot,crumbs,returntop
},
data (){
	return {
    title: '',
    mainid: this.$route.query.mainid,
    subid: this.$route.query.subid,
    checkindex:1,
    items: [
      {
        text: "首页",
        to: "/",
        disabled: false
      },
      {
        text: "",
        disabled: true
      },
      {
        text: "",
        disabled: true
      }
    ],
    data: {},
    horizontal: false,
    collapsable: true,
    expandAll: true,
    labelClassName: "bg-white"
  }
},
  created:function(){
    this.getData()
    this.getNav()
  },
  methods: {
    getData(){
      this.$get('/organization/get-organization-tree').then(res => {
        if(res.code == 0){
            var data = res.data
            data[0].label = data[0].text
            data[0].label = data[0].text
            for(var i = 0; i<data[0].children.length; i++){
              data[0].children[i].label = data[0].children[i].text
              for(var j = 0;j<data[0].children[i].children.length;j++){               
                data[0].children[i].children[j].label = data[0].children[i].children[j].text
              }
            }
            this.data = data[0]
        }
			})
    },
		getNav() {    
      this.$get("/nav/get-nav-tree").then(res => {
        if (res.code === 0) {
          let data = res.data  
          if (data) {
            let newData = data.filter((item, index, array) => {
              return item.id === this.mainid
            })
            this.$set(this.items[1], "text", newData[0].text)
            if (newData[0].children) {
              let subData = newData[0].children
              let newSubData = subData.filter((item, index, array) => {
                return item.id === this.subid
              });
              this.$set(this.items[2], "text", newSubData[0].text)
              this.title = newSubData[0].text
            }
          }
        } else {
          // console.log(res.message)
        }
      })
    }
  }
}
</script>

<style>
.text-center{
    margin-bottom: 50px;
    overflow-x: scroll;
}
.org-tree-node-label .org-tree-node-label-inner {
    font-size: 24px;
}
</style>
